module.exports = __webpack_public_path__ + "img/close.15cfcf61.png";